import { CheckCircleIcon, ExclamationIcon, InformationCircleIcon, ExclamationCircleIcon } from "@heroicons/react/solid";
export const VALIDATION_VARIANTS = {
  success: "success",
  warning: "warning",
  info: "info",
  error: "error"
};
export const VALIDATION_ICON_MAP = {
  success: CheckCircleIcon,
  warning: ExclamationIcon,
  info: InformationCircleIcon,
  error: ExclamationCircleIcon
};